<script>

export default {
  props: ['item', 'packages', 'services'],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    computedPackages: function() {
      var found = false;
      return JSON.parse(JSON.stringify(this.packages)).filter(b => {
        // Hide active_package and any packages less than it
        // if(this.item.active_package && this.item.active_package.id){
        //   if(b.id == this.item.active_package.id) { found = true; return false; }
        //   return found;
        // }
        return true;
      }).map(b => {
        // Subtract packages_total from package prices
        // if(this.item.packages_total && parseFloat(this.item.packages_total) > 0) {
        //   b.price = (!(parseFloat(b.price) - parseFloat(this.item.packages_total) > 0) ? 0 : parseFloat(b.price) - parseFloat(this.item.packages_total));
        // }
        // Adjust package price if upcharge by zip code
        for(var i in b.upcharges) {
          if(this.item.PostalCode && b.upcharges[i].zip_code == this.item.PostalCode && b.upcharges[i].active == "1"){ b.price = parseFloat(b.price) + parseFloat(b.upcharges[i].upcharge); break; }
        }
        // Adjust package price if upcharge by listings
        for(var i in b.upcharges_listings) {
          if(b.upcharges_listings[i].active == "1" && b.upcharges_listings[i].condition == "greater_than" && parseInt(this.item.listings_count) > parseInt(b.upcharges_listings[i].value)) {
            b.price = parseFloat(b.price) + parseFloat(b.upcharges_listings[i].upcharge);
            console.log("Upcharging");
          } else if(b.upcharges_listings[i].active == "1" && b.upcharges_listings[i].condition == "less_than" && parseInt(this.item.listings_count) < parseInt(b.upcharges_listings[i].value)) {
            b.price = parseFloat(b.price) + parseFloat(b.upcharges_listings[i].upcharge);
          }
        }
        return b
      });
    },
    used_services: function() {
      // Used to hide package services alreading included on previous packages
      var results = [], used = [];
      if(this.computedPackages) { for(var i in this.computedPackages) {
        var services = [];
        if(this.computedPackages[i].services) { for(var j in this.computedPackages[i].services) {
          if(used.includes(this.computedPackages[i].services[j].id)) {
            services.push(this.computedPackages[i].services[j].id);
          } else {
            used.push(this.computedPackages[i].services[j].id);
          }
        } }
        results.push(services);
      } }
      return results;
    },
    additionalServices: function () {
      return JSON.parse(JSON.stringify(this.services)).filter(b => {
        // Check if additional service
        if(!b.additional) { return false; }

        // Check if initial service
        if(!b.initial) { return false; }

        // Check if purchased before and is a once service.
        if(b.once) {
          if(this.item.cart.package.services) { for(var i in this.item.cart.package.services) {
            if(this.item.cart.package.services[i].id == b.id) { return false; }
          } }
        }

        return true;
      }).map(b => {
        b.active = false;
        for(var i in b.upcharges) {
          if(this.item.PostalCode && b.upcharges[i].zip_code == this.item.PostalCode && b.upcharges[i].active == "1"){ b.price = parseFloat(b.price) + parseFloat(b.upcharges[i].upcharge); break; }
        }
        return b
      })
    },
  },
  created() {

  },
  methods: {
    toggle_packages(pack) {
      this.item.cart.services = [];
      if(this.item.cart.package.id == pack.id) {
        this.item.cart.package = {};
      } else {
        var new_package = {
          id: pack.id,
          title: pack.title,
          services: [],
          price: parseFloat(pack.price),
          quantity: 1,
        };
        for(var i in pack.services) {
          new_package.services.push({
            id : pack.services[i].id,
            title : pack.services[i].title,
            description : pack.services[i].description,
          });
        }
        this.item.cart.package = new_package;
      }
    },
    toggle_service(service) {
      var found = false;
      for(var i in this.item.cart.services) {
        if(this.item.cart.services[i].id == service.id) {
          this.item.cart.services.splice(i, 1);
          found = true;
        }
      }
      if(!found) {
        var new_service = {
          id: service.id,
          title: service.title,
          description: service.description,
          price: parseFloat(service.price),
          quantity: 1,
          once: service.once,
        };
        this.item.cart.services.push(new_service);
      }
    },
    submit_form() {
      if(this.loading == true) { console.log("disabled"); return; } this.loading = true;
      if(
        Object.keys(this.item.cart.package).length === 0
      ) {
        this.$noty.error("Please select a package before continuing.");
        this.loading = false;
        return;
      }
      this.$emit('setpage', 5);
      this.loading = false;
    },
  }
}
</script>

<template>
  <div class="_w-m-1400 mx-auto my-5">
    <form @submit.prevent="submit_form()">
      <div class="text-center mb-5 _w-m-1000 mx-auto">
        <img :src="formatImage('/fm/revinre-nc/clip art/Packages and Services.jpg')" class="_w-m-400" data-aos="fade-zoom-in">
        <h3 class="mb-3" data-aos="fade-zoom-in">Build your package</h3>
        <p class="text-muted" data-aos="fade-zoom-in">You can start with the basics for free and purchase additional services as needed, or you can start off picking exactly what you need from the start.</p>
      </div>
      
      <div class="row m-0 justify-content-center mb-5">
        <div v-for="(pack, pack_i) in computedPackages" :key="pack_i" class="col _w-n-255 _w-m-400 p-2" data-aos="fade-zoom-in">
          <div class="card grow text-center p-4 pb-5 h-100 position-relative _c-pointer" @click="toggle_packages(pack)">
            <div v-if="pack.ribbon_text && pack.ribbon_color" class="ribbon-two ribbon-lg " :class="'ribbon-two-'+pack.ribbon_color"><span>{{pack.ribbon_text}}</span></div>
            <h3 class="h2 m-0">{{pack.title}}</h3>
            <p class="mb-4">{{pack.sub_title}}</p>
            <p class="h3 m-0">{{formatPrice(pack.price, true, false)}}</p>
            <p class="mb-5">{{pack.sub_price}}</p>
            <ul class="list-unstyled text-left font-weight-600">
              <li v-if="pack_i > 0" class="border-bottom border-fade-d-01 mb-2 pb-2 font-weight-bold" :content="'* Includes '+packages[pack_i-1].title+' services'" v-tippy>
                * Includes {{packages[pack_i-1].title}} services
              </li>
              <li v-for="(serv, serv_i) in pack.services" :key="serv_i" v-if="!used_services[pack_i].includes(serv.id)" class="border-bottom border-fade-d-01 mb-2 pb-2" v-tippy :content="serv.description" @show="() => serv.description ? true : false">
                {{serv.title}} <Icon v-if="serv.description" icon="ri:information-fill" class="text-gray-400"></Icon>
              </li>
            </ul>
            <div class="text-center position-absolute _pos-b-0 _pos-l-0 _pos-r-0 p-3">
              <button v-if="item.cart.package.id == pack.id" type="button" class="btn btn-success px-5">Selected</button>
              <button v-else type="button" class="btn btn-light px-5">Select</button>
            </div>
          </div>
        </div>
      </div>


      <div class="text-center py-5">
        <Icon icon="ri:hand-heart-line" height="45" class="text-revinre mb-2" />
        <h3 class="mb-3" data-aos="fade-zoom-in">A La Carte services</h3>
        <p class="text-muted" data-aos="fade-zoom-in" data-aos-delay="200">One of the best parts of the {{ app_name }} system is the ability to pick and choose only the services you truly need.</p>
      </div>
      <div class="row m-0 mb-5">
        <div v-for="(serv, serv_i) in additionalServices" :key="serv_i" class="col-sm-6 col-md-4 p-1" data-aos="fade-zoom-in" v-tippy :content="serv.description" @show="() => serv.description ? true : false">
          <div class="p-sm-2 h-100 grow rounded _c-pointer" @click="toggle_service(serv)" :class="item.cart.services.filter(b => { if(b.id == serv.id) { return true; } else { return false; } }).length ? 'bg-success text-white' : 'bg-gray-100'">
            <p class="m-0 p-1 font-weight-bold">
              <Icon v-if="item.cart.services.filter(b => { if(b.id == serv.id) { return true; } else { return false; } }).length" icon="ri:checkbox-line" height="25" class="mr-2" />
              <Icon v-else icon="ri:checkbox-blank-line" height="25" class="mr-2" />
              {{serv.title}} <Icon v-if="serv.description" icon="ri:information-fill" class="text-muted" /> <span :class="item.cart.services.filter(b => { if(b.id == serv.id) { return true; } else { return false; } }).length ? 'text-white' : 'text-muted'">({{formatPrice(serv.price, true, false)}})</span></p>
          </div>
        </div>
      </div>

      <div class="row py-5 _w-m-1000 mx-auto">
        <div class="col-6">
          <button type="button" class="btn btn-lg btn-success" @click="$emit('setpage', 3)" :disabled="loading"><Icon icon="ri:arrow-left-double-fill" /> Previous</button>
        </div>
        <div class="col-6 text-right">
          <button type="submit" class="btn btn-lg btn-success" :disabled="loading"><span class="spinner-border spinner-border-sm" v-show="loading"></span> Next <Icon icon="ri:arrow-right-double-fill" /></button>
        </div>
      </div>
    </form>
  </div>
</template>
